import { Form, Formik } from 'formik'
import { observer } from 'mobx-react-lite'
import React, { useContext, useState } from 'react'
import { useParams } from 'react-router-dom'
import { CampaignContext } from '../../../../../../../contexts/CampaignContext'
import axiosService from '../../../../../../../utils/AxiosService'
import Input from '../../../../../../FormComponents/Input'
import { toastError, toastSuccess } from '../../../../../../FormComponents/Toasts'
import { useReadOnly } from '../../../../../../../contexts/ReadOnlyContext'

export default observer(function BuyoutPriceField({ action }) {
  const readOnly = useReadOnly()
  const { campaign, primaryScenarioId } = useContext(CampaignContext)
  const { id } = useParams()
  const [currentTimeout, setCurrentTimeout] = useState(null)

  const changeBuyoutPrice = buyout_price => {
    if (currentTimeout) clearTimeout(currentTimeout)
    setCurrentTimeout(setTimeout(() => submitBuyoutPrice(buyout_price), 1000))
  }

  const handleFormSubmit = values => {
    if (currentTimeout) clearTimeout(currentTimeout)
    const price = typeof values?.buyout_price === 'object'
      ? values.buyout_price?.buyout_price
      : values?.buyout_price
    submitBuyoutPrice(price)
  }

  const submitBuyoutPrice = buyout_price => {
    axiosService.patch(`/api/project_manager/campaigns/${id}/campaign_scenarios/${primaryScenarioId}/actions/${action.id}`, { campaign_scenario_action: { buyout_price }})
    .then((updatedAction) => {
      toastSuccess('Buyout Price updated')
      action.buyout_price = updatedAction.buyout_price
    })
    .catch(({ data: { error }}) => toastError(error))
  }

  return (
    <div>
      <Formik
        key={action.buyout}
        initialValues={{ buyout_price: action.buyout_price }}
        onSubmit={handleFormSubmit}
      >
        {({ errors, touched, handleBlur, handleChange, values }) => (
          <Form className="w-full">
            <div className="relative">
              <Input
                addon={campaign.currency_symbol}
                addonPosition="start"
                error={touched.buyout_price && errors.buyout_price}
                name="buyout_price"
                noLabelPadding
                onChange={(e) => {
                  changeBuyoutPrice(e.target.value)
                  handleChange(e)
                }}
                onBlur={handleBlur}
                value={values.buyout_price}
                disabled={readOnly || !action.buyout}
                overrideClassName="h-7"
                topMargin="mt-0"
              />
            </div>
          </Form>
        )}
      </Formik>
    </div>
  )
})